import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DistributionInterface } from 'app/models/distribution.model';
import { RequestService } from 'app/modules/common/utils/request.service';
import { Observable } from 'rxjs';
import { DistributionDataTransformPost } from './data-transforms/distribution.data.transform.post';
import { DistributionDataTransformGet } from './data-transforms/distribution.data.transform.get';

@Injectable({
  providedIn: 'root',
})
export class DistributionHttpInterceptor implements HttpInterceptor {
  private readonly _rexp = new RegExp(/^\/distributions(\/[0-9a-z]{24})?$/);

  constructor(
    private readonly _transformUp: DistributionDataTransformGet,
    private readonly _transformDown: DistributionDataTransformPost,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return RequestService.getTransformedHttpEvent<DistributionInterface>(
      req,
      next,
      this._rexp,
      this._transformDown,
      this._transformUp,
    );
  }
}
